import { IErrorResponseType, IInstitutionListResponse, ISuccessResponseType } from "../../constants/commonTypes";
import * as UploadDocumentActions from "../actionTypes/uploadDocumentActionTypes";
import { UploadDetailsState } from "../reducers/uploadDocumentReducer";

// Getting Institutions

export function getInstitutionList(query: string): UploadDocumentActions.GetInstitutionListAction {
  return {
    type: UploadDocumentActions.GET_INSTITUTION_LIST,
    query
  };
}

export function getInstitutionListRequest(): UploadDocumentActions.GetInstitutionListRequestAction {
  return {
    type: UploadDocumentActions.GET_INSTITUTION_LIST_REQUEST
  }
}

export function getInstitutionListSuccess(response: IInstitutionListResponse[]): UploadDocumentActions.GetInstitutionListSuccessAction {
  return {
    type: UploadDocumentActions.GET_INSTITUTION_LIST_SUCCESS,
    institutionList: response
  }
}

export function getInstitutionListFailure(error: Error | string | IErrorResponseType): UploadDocumentActions.GetInstitutionListFailureAction {
  return {
    type: UploadDocumentActions.GET_INSTITUTION_LIST_FAILURE,
    error
  }
}

// Initiating Upload Documents

export function initiateUploadDoc(request: object): UploadDocumentActions.InititateUploadDocAction {
  return {
    type: UploadDocumentActions.INITIATE_UPLOAD_DOC,
    request
  };
}

export function initiateUploadDocRequest(): UploadDocumentActions.InititateUploadDocRequestAction {
  return {
    type: UploadDocumentActions.INITIATE_UPLOAD_DOC_REQUEST
  }
}

export function initiateUploadDocSuccess(response: string): UploadDocumentActions.InititateUploadDocSuccessAction {
  return {
    type: UploadDocumentActions.INITIATE_UPLOAD_DOC_SUCCESS,
    initiateResponse: response
  }
}

export function initiateUploadDocFailure(error: Error | string | IErrorResponseType): UploadDocumentActions.InititateUploadDocFailureAction {
  return {
    type: UploadDocumentActions.INITIATE_UPLOAD_DOC_FAILURE,
    error
  }
}


// Uploading Documents


export function uploadDocuments(perfTxnId: string, documents: FormData): UploadDocumentActions.UploadDocumentsAction {
  return {
    type: UploadDocumentActions.UPLOAD_DOCUMENTS,
    perfTxnId,
    documents,
  };
}

export function uploadDocumentRequest(): UploadDocumentActions.UploadDocumentsRequstAction {
  return {
    type: UploadDocumentActions.UPLOAD_DOCUMENTS_REQUEST
  }
}

export function uploadDocumentSuccess(uploadDocumentResponse: ISuccessResponseType[]): UploadDocumentActions.UploadDocumentSuccessAction {
  return {
    type: UploadDocumentActions.UPLOAD_DOCUMENTS_SUCCESS,
    uploadDocumentResponse
  }
}

export function uploadDocumentFailure(error: Error | string | IErrorResponseType): UploadDocumentActions.UploadDocumentFailureAction {
  return {
    type: UploadDocumentActions.UPLOAD_DOCUMENTS_FAILURE,
    error
  }
}

export function uploadDocumentReset(): UploadDocumentActions.UploadDocumentResetAction {
  return {
    type: UploadDocumentActions.UPLOAD_DOCUMENTS_RESET,
  }
}

// Uploading Details (Called when InApp Back is pressed)
export function uploadDetails(request: object): UploadDocumentActions.UploadDetailsAction {
  return {
    type: UploadDocumentActions.UPLOAD_DETAILS,
    request
  };
}

export function uploadDetailsRequest(): UploadDocumentActions.UploadDetailsRequstAction {
  return {
    type: UploadDocumentActions.UPLOAD_DETAILS_REQUEST
  }
}

export function uploadDetailsSuccess(response: UploadDetailsState): UploadDocumentActions.UploadDetailsSuccessAction {
  return {
    type: UploadDocumentActions.UPLOAD_DETAILS_SUCCESS,
    institutionName: response.institutionName,
    fileList: response.fileList,
    passwordFlag: response.passwordFlag,
  }
}

export function uploadDetailsFailure(error: Error | string | IErrorResponseType): UploadDocumentActions.UploadDetailsFailureAction {
  return {
    type: UploadDocumentActions.UPLOAD_DETAILS_FAILURE,
    error
  }
}


// Resume Journey (Called from thank you screen)
export function resumeJourney(): UploadDocumentActions.ResumeJourneyAction {
  return {
    type: UploadDocumentActions.RESUME_JOURNEY
  };
}

export function resumeJourneyRequest(): UploadDocumentActions.ResumeJourneyRequstAction {
  return {
    type: UploadDocumentActions.RESUME_JOURNEY_REQUEST
  }
}

export function resumeJourneySuccess(resumeJourneyResponse: boolean): UploadDocumentActions.ResumeJourneySuccessAction {
  return {
    type: UploadDocumentActions.RESUME_JOURNEY_SUCCESS,
    resumeJourneyResponse
  }
}

export function resumeJourneyFailure(error: Error | string | IErrorResponseType): UploadDocumentActions.ResumeJourneyFailureAction {
  return {
    type: UploadDocumentActions.RESUME_JOURNEY_FAILURE,
    error
  }
}